import angular from "angular"
import "./login.css"

loginController.$inject = ["loginService"]
function getQueryParam(param) {
  const params = new URLSearchParams(window.location.search)
  return params.get(param)
}

function loginController(loginService) {
  var self = this
  self.message = ""
  self.showLoginForm = false

  self.login = function() {
    // console.log(self.username, self.password);
    loginService.login(self.username, self.password, function() {
      self.message = "usuario o contraseña incorrectos"
    })
  }

  self.getRedirectUrl = function() {
    loginService.getRedirectUrl(function(redirectUrl) {
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        self.showLoginForm = true
      }
    })
  }

  self.$onInit = function() {
    const accessToken = getQueryParam("access_token")

    if (accessToken) {
      loginService.validateToken(accessToken, function(success) {
        self.message = "No se pudo logear el usario mediante identity"
        self.showLoginForm = true
      })
    } else {
      self.getRedirectUrl()
    }
  }

  self.clear = function() {
    self.message = ""
  }
}

angular.module("appModule").controller("loginController", loginController)
